import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    saldoCajas: 0,
    saldoBancos: 0,
    saldoChequesTerceros: 0,
    cotizacionDolar: 0,
    flujoFondos: [],
    flujoFondosFields: [],
    flujoFondosForExport: [],
    flujoFondosCols: [],

    resultados: [],
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,   
};

const mutations = {
    updateField,

    'INICIALIZAR_FLUJO_FONDOS' (state) {
        state.fechaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.saldoCajas = 0;
        state.saldoBancos = 0;
        state.saldoChequesTerceros = 0;
        state.cotizacionDolar = 0;
        state.flujoFondos = [];
        state.flujoFondosFields = [];
        state.flujoFondosForExport = [];
        state.flujoFondosCols = [];
    },
    'SET_FLUJO_FONDOS' (state, flujoFondos) {
        state.fechaDesde = moment(flujoFondos.fechaDesde).format('YYYY-MM-DD');
        state.fechaHasta = moment(flujoFondos.fechaHasta).format('YYYY-MM-DD');
        state.saldoCajas = parseFloat(flujoFondos.saldoCajas);
        state.saldoBancos = parseFloat(flujoFondos.saldoBancos);
        state.saldoChequesTerceros = parseFloat(flujoFondos.saldoChequesTerceros);
        state.cotizacionDolar = parseFloat(flujoFondos.cotizacionDolar);
        state.flujoFondos = [];
        state.flujoFondosFields = [];
        state.flujoFondosForExport = [];

        let column = 1;
        let saldoInicial = {};
        let bancosIngresos = {};
        let chequesTerceros = {};
        let clientes = {};
        let saldoIngresos = {};
        let bancosEgresos = {};
        let chequesPropios = {};
        let tarjetas = {};
        let sueldos = {};
        let impuestos = {};
        let alquileres = {};
        let proveedores = {};
        let saldoEgresos = {};
        let saldoFinal = {};

        let saldoInicialXls = {};
        let bancosIngresosXls = {};
        let chequesTercerosXls = {};
        let clientesXls = {};
        let saldoIngresosXls = {};
        let bancosEgresosXls = {};
        let chequesPropiosXls = {};
        let tarjetasXls = {};
        let sueldosXls = {};
        let impuestosXls = {};
        let alquileresXls = {};
        let proveedoresXls = {};
        let saldoEgresosXls = {};
        let saldoFinalXls = {};

        let col = {
            key: '0',
            label: 'Período',
            stickyColumn: true,
            isRowHeader: true,
            thClass: 'titles',
        }
        state.flujoFondosFields.push(col);

        saldoInicial[0] = 'Saldo Inicial';
        bancosIngresos[0] = 'Bancos - Ingresos';
        chequesTerceros[0] = 'Cheques Terceros';
        clientes[0] = 'Clientes';
        saldoIngresos[0] = 'Saldo Ingresos';
        bancosEgresos[0] = 'Bancos - Egresos';
        chequesPropios[0] = 'Cheques Propios';
        tarjetas[0] = 'Tarjetas';
        sueldos[0] = 'Sueldos';
        impuestos[0] = 'Impuestos';
        alquileres[0] = 'Alquileres';
        proveedores[0] = 'Proveedores';
        saldoEgresos[0] = 'Saldo Egresos';
        saldoFinal[0] = 'Saldo Final';

        /* Formato para exportar (xls) */
        saldoInicialXls[0] = 'Saldo Inicial';
        bancosIngresosXls[0] = 'Bancos - Ingresos';
        chequesTercerosXls[0] = 'Cheques Terceros';
        clientesXls[0] = 'Clientes';
        saldoIngresosXls[0] = 'Saldo Ingresos';
        bancosEgresosXls[0] = 'Bancos - Egresos';
        chequesPropiosXls[0] = 'Cheques Propios';
        tarjetasXls[0] = 'Tarjetas';
        sueldosXls[0] = 'Sueldos';
        impuestosXls[0] = 'Impuestos';
        alquileresXls[0] = 'Alquileres';
        proveedoresXls[0] = 'Proveedores';
        saldoEgresosXls[0] = 'Saldo Egresos';
        saldoFinalXls[0] = 'Saldo Final';
        
        flujoFondos.periodos.forEach(periodo => {
            column++;
            
            let flujoFondosCol = {
                col: column,
                fechaDesde: periodo.fecha,
                fechaHasta: periodo.fecha
            }

            let tituloPeriodo = moment(periodo.fecha).format('DD-MM'); 

            if ((/true/i).test(periodo.totalesSemanales)) {
                tituloPeriodo = `${moment(periodo.fechaDesde).format('DD-MM')} al ${moment(periodo.fechaHasta).format('DD-MM')}`; 
                
                flujoFondosCol.fechaDesde = periodo.fechaDesde;
                flujoFondosCol.fechaHasta = periodo.fechaHasta;
            }

            if ((/true/i).test(periodo.totalesMensuales)) {
                tituloPeriodo = `${moment(periodo.fechaDesde).format('DD-MM')} al ${moment(periodo.fechaHasta).format('DD-MM')}`; 
                
                flujoFondosCol.fechaDesde = periodo.fechaDesde;
                flujoFondosCol.fechaHasta = periodo.fechaHasta;
            }

            state.flujoFondosCols.push(flujoFondosCol);            

            let col = {
                key: column.toString(),
                label: tituloPeriodo,
                class: { 
                    'text-right' : true, 
                    'totales-semanales': (/true/i).test(periodo.totalesSemanales),
                    'totales-mensuales': (/true/i).test(periodo.totalesMensuales)  
                },
            }
            state.flujoFondosFields.push(col);

            saldoInicial[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.saldoInicial); 
            if ((/true/i).test(periodo.totalesSemanales) ||  (/true/i).test(periodo.totalesMensuales)) {
                saldoInicial[column] = '';
            }
            bancosIngresos[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.bancosIngresos); 
            chequesTerceros[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.chequesTerceros); 
            clientes[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.clientes); 
            saldoIngresos[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.saldoIngresos); 
            bancosEgresos[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.bancosEgresos); 
            chequesPropios[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.chequesPropios); 
            tarjetas[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.tarjetas); 
            sueldos[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.sueldos); 
            impuestos[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.impuestos); 
            alquileres[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.alquileres); 
            proveedores[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.proveedores);
            saldoEgresos[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.saldoEgresos); 
            saldoFinal[column] = new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(periodo.saldoFinal);
            if ((/true/i).test(periodo.totalesSemanales) ||  (/true/i).test(periodo.totalesMensuales)) {
                saldoFinal[column] = '';
            }

            /* Formato para exportar (xls) */
            saldoInicialXls[column] = periodo.saldoInicial; 
            if ((/true/i).test(periodo.totalesSemanales) ||  (/true/i).test(periodo.totalesMensuales)) {
                saldoInicialXls[column] = '';
            }
            bancosIngresosXls[column] = periodo.bancosIngresos; 
            chequesTercerosXls[column] = periodo.chequesTerceros; 
            clientesXls[column] = periodo.clientes; 
            saldoIngresosXls[column] = periodo.saldoIngresos; 
            bancosEgresosXls[column] = periodo.bancosEgresos; 
            chequesPropiosXls[column] = periodo.chequesPropios; 
            tarjetasXls[column] = periodo.tarjetas; 
            sueldosXls[column] = periodo.sueldos; 
            impuestosXls[column] = periodo.impuestos; 
            alquileresXls[column] = periodo.alquileres; 
            proveedoresXls[column] = periodo.proveedores;
            saldoEgresosXls[column] = periodo.saldoEgresos; 
            saldoFinalXls[column] = periodo.saldoFinal;
            if ((/true/i).test(periodo.totalesSemanales) ||  (/true/i).test(periodo.totalesMensuales)) {
                saldoFinalXls[column] = '';
            }            
        });

        state.flujoFondos = [];
        state.flujoFondos.push(saldoInicial);
        state.flujoFondos.push(bancosIngresos);
        state.flujoFondos.push(chequesTerceros);
        state.flujoFondos.push(clientes);
        state.flujoFondos.push(saldoIngresos);
        state.flujoFondos.push(bancosEgresos);
        state.flujoFondos.push(chequesPropios);
        state.flujoFondos.push(tarjetas);
        state.flujoFondos.push(sueldos);
        state.flujoFondos.push(impuestos);
        state.flujoFondos.push(alquileres);
        state.flujoFondos.push(proveedores);
        state.flujoFondos.push(saldoEgresos);
        state.flujoFondos.push(saldoFinal);

        /* Formato para exportar (xls) */
        state.flujoFondosForExport = [];
        state.flujoFondosForExport.push(saldoInicialXls);
        state.flujoFondosForExport.push(bancosIngresosXls);
        state.flujoFondosForExport.push(chequesTercerosXls);
        state.flujoFondosForExport.push(clientesXls);
        state.flujoFondosForExport.push(saldoIngresosXls);
        state.flujoFondosForExport.push(bancosEgresosXls);
        state.flujoFondosForExport.push(chequesPropiosXls);
        state.flujoFondosForExport.push(tarjetasXls);
        state.flujoFondosForExport.push(sueldosXls);
        state.flujoFondosForExport.push(impuestosXls);
        state.flujoFondosForExport.push(alquileresXls);
        state.flujoFondosForExport.push(proveedoresXls);
        state.flujoFondosForExport.push(saldoEgresosXls);
        state.flujoFondosForExport.push(saldoFinalXls);
    },

    'INICIALIZAR_RESULTADOS'(state) {
        state.resultados = [];
        state.paginaActual = 1;
        state.totalRegistros = 0;

    },
    'SET_RESULTADOS'(state, resultados) {
        state.resultados = resultados;
        state.paginaActual = 1;
        state.totalRegistros = resultados.length;
    }
};

const getters = {
    getField,

    resultados(state) {
        return state.resultados;
    }
};

const actions = {
    getFlujoFondos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_FLUJO_FONDOS');

            apiAxios.get('flujo-fondos')
                .then(res => {
                    commit('SET_FLUJO_FONDOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getDeudaClientes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/deuda-clientes' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getDeudaProveedores ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/deuda-proveedores' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
    getChequesPropios ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/cheques-propios' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getChequesTerceros ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/cheques-terceros' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getTarjetasResumenes ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/tarjetas' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getBancosIngresos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/bancos/ingresos' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getBancosEgresos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('flujo-fondos/bancos/egresos' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}